import * as React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import Modal, {
  ModalContent,
  ModalFooter,
  ModalHeader,
  Styled,
} from "@8x8/oxygen-modal";
import Button from "@8x8/oxygen-button";
import { Spinner } from "@8x8/oxygen-loaders";

import MainContent from "./modal/MainContent";

/**
 * This wrapper should contain the ModalHeader, ModalContent
 * and ModalFooter in order to apply custom styles to them.
 *
 * NOTE: Styled.Content and Styled.Container DO NOT work, so
 *  workarounds need to be used for those.
 */
export const CustomWrapper = styled.div`
  ${Styled.HeaderContainer} {
    display: flex;
    flex-direction: column;

    align-items: flex-start;
    justify-content: space-between;
    padding: 16px;
  }
`;

export const LoadingSpinner = styled(Spinner)`
  margin: 0;
`;

const JobDetailsModal = ({ isOpen, setIsOpen, isFetchingJobDetails, data }) => {
  const navigate = useNavigate();
  const onClose = React.useCallback(() => {
    setIsOpen(false);

    // Navigate to the very same URL (PATHS.JOB_INVENTORY if we need absolute),
    // but without the :job_id attribute.
    navigate("/jobs", { replace: true });
  }, [navigate, setIsOpen]);

  return (
    <Modal
      isVisible={isOpen}
      size={"big"}
      onClose={onClose}
      shouldCloseOnEsc
      allowOutsideClick
      shouldCloseOnOverlayClick
    >
      <CustomWrapper>
        <ModalHeader title={`Job #${data?.id ?? data?.jobId}`} />
        <ModalContent>
          {isFetchingJobDetails && <LoadingSpinner />}
          {!isFetchingJobDetails && <MainContent job={data} />}
        </ModalContent>
        <ModalFooter>
          <Button secondary onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </CustomWrapper>
    </Modal>
  );
};

export default JobDetailsModal;
